module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/lte-2-d20c99453f4f4758efc53f1ce87a19ed.svg";